module.exports = __webpack_public_path__ + "images/cd22bb3b20e12f220cca9db79c7075bf-logoXpoPRO.png";